import { Component, OnInit, Optional, Self, ChangeDetectionStrategy } from '@angular/core';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';
import { delay, filter, takeUntil, tap } from 'rxjs/operators';
import { MineFontsGQL } from 'ZalamoLibrary/src/lib/ui/fonts-manager/graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { FontListComponent } from 'ZalamoLibrary/src/lib/ui/fonts-manager/font-list/font-list.component';

@Component({
    selector: 'lib-font-inline-picker',
    templateUrl: './font-inline-picker.component.html',
    styleUrls: ['./font-inline-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FontInlinePickerComponent
  extends AbstractValueAccessor
  implements OnInit {
  control = new UntypedFormControl('');

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private mineFontsGQL: MineFontsGQL,
    private organizationService: OrganizationService,
    private zalamoDialogService: ZalamoDialogService
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    let updateInProgress = false;

    this.subscribeWhileAlive(
      this.valueSubject.pipe(
        RxjsOperators.filterTruthy(),
        filter(() => !updateInProgress),
        delay(500),
        tap((fontId) => {
          updateInProgress = true;

          this.control.patchValue(fontId, { emitEvent: false });
          updateInProgress = false;
        })
      ),
      this.control.valueChanges.pipe(
        filter(() => !updateInProgress),
        tap((v) => {
          updateInProgress = true;
          this.writeValue(this.control.value);
          updateInProgress = false;
        })
      )
    );
  }

  pickFont() {
    const ref = this.zalamoDialogService.openRight(FontListComponent);

    ref.componentInstance.picked
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(({ fileName, fontId }) => {
        this.control.patchValue({
          fileName,
          fontId,
        });
        ref.close();
      });
  }
}
